import { OrderedList } from "@tiptap/extension-ordered-list";

const OrderedListCustom = OrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: null,
        parseHTML: (element) => {
          const type = element.getAttribute("type");
          const style = element.getAttribute("style");
          // Check style attribute for list-style-type
          if (style && style.includes("list-style-type")) {
            const match = style.match(/list-style-type:\s*([^;]+)/);
            if (match) {
              return match[1].trim();
            }
          }
          return type || null;
        },
        renderHTML: (attributes) => {
          if (!attributes.type || attributes.type === "decimal") {
            return {};
          }
          // Return both type attribute and style for maximum compatibility
          return {
            type: attributes.type,
            style: `list-style-type: ${attributes.type};`,
          };
        },
      },
      start: {
        default: null,
        parseHTML: (element) => {
          const start = element.getAttribute("start");
          return start ? parseInt(start, 10) : null;
        },
        renderHTML: (attributes) => {
          if (!attributes.start || attributes.start === 1) {
            return {};
          }
          return {
            start: attributes.start,
          };
        },
      },
      reversed: {
        default: false,
        parseHTML: (element) => element.hasAttribute("reversed"),
        renderHTML: (attributes) => {
          if (!attributes.reversed) {
            return {};
          }
          return {
            reversed: "",
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setOrderedList:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.toggleList(this.name, "listItem", attributes);
        },
    };
  },
});

export default OrderedListCustom;
